import { render } from "./PraticheIntestatario.vue?vue&type=template&id=c8eab0fe"
import script from "./PraticheIntestatario.vue?vue&type=script&lang=js"
export * from "./PraticheIntestatario.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__